require('../fhApp/currentUser/currentUser');

"use strict";

angular.module('app.purchase.purchasePlanService', [
  'app.currentUser'
])
  .factory('app.purchase.purchasePlanService', [
    '$http', 'currentUser', '$q',
    function ($http, currentUser, $q) {
      return {
        purchase: function (plan, billing_token, team, upgrade, uuid = null) {
          let deferred = $q.defer();

          let params = {
            plan_code: plan.plan_code,
            currency: plan.currency,
            billing_info: billing_token,
            coupon_code: (plan.promotion && plan.promotion.coupon_code) ? plan.promotion.coupon_code : ""
          };

          if (team) {
            if (team.hasOwnProperty('iteamid')) {
              params.team_id = team.iteamid
            } else if (team > 0) {
              params.team_id = parseInt(team)
            }
          }

          if (!upgrade) {
            $http.post(window.location.api('subscriptions'), params).then(
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                /**
                 * @type {{subscription: Subscription}}
                 */
                let data = response.data;

                if (data.subscription) {
                  if (plan.currency !== data.subscription.currency) {
                    alert("The plan currency and the subscription currency didn't match. The suscription has been bought with the following currency: " + data.subscription.currency);
                  }

                  currentUser.get_current_subscriptions("recurly");
                  currentUser.subscription_err = null;
                }

                deferred.resolve(data);
              },
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                deferred.reject(response.data);
              }
            );
          }
          else {
            params.action = "upgrade";
            params.subscription_uuid = uuid;

            $http.put(window.location.api('subscriptions/active'), params).then(
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                /**
                 * @type {{subscription: Subscription}}
                 */
                let data = response.data;

                if (data.subscription) {
                  if (plan.currency !== data.subscription.currency) {
                    alert("The plan currency and the subscription currency didn't match. The suscription has been bought with the following currency: " + data.subscription.currency);
                  }

                  currentUser.get_current_subscriptions("recurly");
                  currentUser.subscription_err = null;
                }

                deferred.resolve(data);
              },
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                deferred.reject(response.data);
              }
            );
          }

          return deferred.promise;
        },
        update_subscription: function (action, plan, subscription) {
          let params = { action: action };
          if (plan) {
            params.plan_code = plan.plan_code;
          }

          if (subscription && subscription.uuid) {
            params.subscription_uuid = subscription.uuid
          }

          return $http.put(window.location.api('subscriptions/active'), params)
            .then((response) => {
              let data = response.data;

              if (data.subscriptions) {
                if (data.subscriptions.length > 1) {
                  currentUser.subscription_err = currentUser.multi_subscriptions_message;
                } else if (data.subscriptions.length === 1) {
                  currentUser.update_current_subscription(data.subscriptions[0], "recurly");
                  currentUser.subscription_err = null;
                }
              }

              return response;
            });
        },
        activate_subscription: function (subscription_uuid) {
          let params = {};

          if (subscription_uuid) {
            params.subscription_uuid = subscription_uuid;
          }

          return $http.post(window.location.api('subscriptions/active'), params)
            .then((response) => {
              let data = response.data;

              if (data.subscriptions) {
                if (data.subscriptions.length > 1) {
                  currentUser.subscription_err = currentUser.multi_subscriptions_message;
                } else if (data.subscriptions.length === 1) {
                  currentUser.update_current_subscription(data.subscriptions[0], "recurly");
                  currentUser.subscription_err = null;
                }
              }

              return response;
            });
        },
        upgrade: function (plan, billing_token, team) {
          let deferred = $q.defer();

          let params = {
            plan_code: plan.plan_code,
            currency: plan.currency,
            billing_info: billing_token,
            plan_type: plan.type,
            subscription_uuid: currentUser.subscriptions.recurly.uuid
          };

          if (team && team.hasOwnProperty('iteamid')) {
            params.team_id = team.iteamid
          }

          $http.put(window.location.api('subscriptions'), params).then(
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              /**
               * @type {{subscription: Subscription}}
               */
              let data = response.data;

              if (data.subscription) {
                if (plan.currency !== data.subscription.currency) {
                  alert("The plan currency and the subscription currency didn't match. The suscription has been bought with the following currency: " + data.subscription.currency);
                }

                currentUser.update_current_subscription(data.subscription, "recurly");
                currentUser.subscription_err = null;
              }

              deferred.resolve(data);
            },
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              deferred.reject(response.data);
            }
          );

          return deferred.promise;
        },
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/purchasePlanService.js